export default "__VITE_ASSET__Zo9Gy9_z__"